import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export type Tone = 'green' | 'red' | 'gold' | 'blue' | 'gray' | 'teal';

const tones: Record<Tone, string> = {
  green: 'bg-success-50 text-[#168a63]',
  red: 'bg-danger-50 text-[#c64c50]',
  gold: 'bg-gold-50 text-[#aa761a]',
  blue: 'bg-brand-50 text-brand',
  gray: 'bg-soft text-muted border border-line',
  teal: 'bg-teal-50 text-teal',
};

export function Badge({ tone = 'gray', children, className }: { tone?: Tone; children: ReactNode; className?: string }) {
  return <span className={cn('inline-flex items-center gap-1 rounded-[7px] px-2 py-1 text-[10px] font-bold whitespace-nowrap', tones[tone], className)}>{children}</span>;
}
